module.exports = __webpack_public_path__ + "static/media/aboutus.d2b602cf.jpeg";